import React from 'react';
import {
  Container,
  makeStyles,
  Grid,
} from '@material-ui/core';

import Input from '../../../shared/component/FormElements/Input';
import Draft from '../../../shared/component/FormElements/Draft';
import Button from '../../../shared/component/FormElements/Button';
import {
  VALIDATOR_REQUIRE,
} from '../../../utils/validators';
import { useForm } from '../../../hooks/form-hook';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    color: '#3E3E3E',
    fontWeight: 500,
    fontSize: '33px',
    marginBottom: '16px'
  },
  button: {
    marginTop: '15px',
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    width: '100%'
  },
  cancelar: {
    marginTop: '15px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    width: '100%'
  },
  header: {
    backgroundColor: '#2C3E50',
    color: 'white',
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
  galeria: {
    marginTop: '32px'
  },
  data: {
    color: '#828282',
    fontSize: '14px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    display: 'block',
    width: '100%'
  },
  valor: {
    color: '#828282',
    fontSize: '18px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    display: 'block',
    width: '100%',
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  nome: {
    '& input': {
      color: '#3E3E3E',
      fontWeight: 500,
      fontSize: '33px',
    },
    '& fieldset': {
      border: 'none'
    }
  },
  mais: {
    width: '100%',
    height: '87px',
    display: 'flex',
    backgroundColor: '#F3F3F3',
    overflow: 'hidden'
  },
  icone: {
    fontSize: '50px',
    color: '#ACACAC'
  }
}));

const Faq = (props) => {
  const classes = useStyles();
  const {
    close,
    salvar,
    atualizar,
    edit
  } = props;
  const [formState, inputHandler] = useForm({
    pergunta: {
      value: '',
      isValid: false
    },
    resposta: {
      value: '',
      isValid: true
    },
  }, false);

  const cadastrarFaq = async (event) => {
    event.preventDefault();
    console.log(formState.inputs);
    if (edit !== undefined) {
      atualizar({
        qual: edit,
        pergunta: formState.inputs.pergunta.value,
        resposta: formState.inputs.resposta.value,
      });
    } else {
      salvar({
        pergunta: formState.inputs.pergunta.value,
        resposta: formState.inputs.resposta.value,
      });
    }
  };

  return (
    <Container maxWidth="xl">
      <form onSubmit={cadastrarFaq}>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Input
              id="pergunta"
              element="input"
              type="text"
              label="Botão da Área"
              fullWidth
              validators={[VALIDATOR_REQUIRE()]}
              onInput={inputHandler}
              initialValue={edit !== undefined ? edit.pergunta : undefined}
              initialValid={edit !== undefined}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Draft
              id="resposta"
              element="input"
              type="text"
              label="Descrição lateral"
              fullWidth
              validators={[VALIDATOR_REQUIRE()]}
              initialValue={edit !== undefined ? edit.resposta : false}
              initialValid={edit !== undefined}
              onInput={inputHandler}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              type="button"
              marginBottom={5}
              color="info"
              variant="contained"
              size="large"
              classes={classes.cancelar}
              onClick={() => close()}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              color="secondary"
              disabled={!formState.isValid}
              size="large"
              type="submit"
              variant="contained"
              marginBottom={5}
              classes={classes.button}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};
export default Faq;
